export const CoreInitiativesLinksByIdName = 'CoreInitiativesLinksById';
